import { type FC } from "react";
import { DatePicker, type DatePickerProps } from "antd";
import type { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";
import { mergeDashboardPickerPopupClass } from "./arabicIndicPanelDigits";
import { useArabicIndicPickerOpenChange } from "./useArabicIndicPickerOpenChange";

export type DashboardAntDatePickerProps = DatePickerProps<Dayjs>;

export const DashboardAntDatePicker: FC<DashboardAntDatePickerProps> = ({
  popupClassName,
  onOpenChange,
  ...rest
}) => {
  const { i18n } = useTranslation();
  const isArabic = (i18n.resolvedLanguage ?? i18n.language ?? "en").toLowerCase().startsWith("ar");
  const handleOpenChange = useArabicIndicPickerOpenChange(isArabic, onOpenChange);

  return (
    <DatePicker
      {...rest}
      popupClassName={mergeDashboardPickerPopupClass(popupClassName)}
      onOpenChange={handleOpenChange}
    />
  );
};
